<template>
    <select class="c-select" :disabled="!items.length" v-model="value" @change="select">
        <option :value="null">{{ placeholder }}</option>
        <option v-for="(item, index) in items"
                :value="item.alias"
                :key="index">
            {{ item.name }}
        </option>
    </select>
</template>

<script>
    export default {
        props: {
            items: { type: Array },
            value: {
                type: String,
                default: null
            },
            placeholder: { type: String }
        },
        methods: {
            select: function () {
                this.$emit("select", this.value);
            }
        }
    };
</script>